import {
  Category,
  SubcategoryOption,
  SubcategoryOptionsMap,
} from '@immosky/types';

export const availableIndustrySubcategories: SubcategoryOption[] = [
  {
    text: 'filters.category.sub.businessHouse',
    value: 'business-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.commercialResidentialBuilding',
    value: 'commercial-residential-building',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.office',
    value: 'office',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.shop',
    value: 'shop',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.warehouse',
    value: 'warehouse',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.factory',
    value: 'factory',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.hotel',
    value: 'hotel',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.restaurant',
    value: 'restaurant',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.practice',
    value: 'practice',
    isChecked: false,
  },
];

export const availableIncomePropertySubcategories: SubcategoryOption[] = [
  {
    text: 'filters.category.sub.multiFamilyHouse',
    value: 'multi-family-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.commercialResidentialBuilding',
    value: 'commercial-residential-building',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.businessHouse',
    value: 'business-house',
    isChecked: false,
  },
];

export const availableEstateSubcategories: SubcategoryOption[] = [
  {
    text: 'filters.category.sub.buildingLand',
    value: 'building-land',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.agriculturalLand',
    value: 'agricultural-land',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.industrialLand',
    value: 'industrial-land',
    isChecked: false,
  },
];

export const availableApartmentSubcategories: SubcategoryOption[] = [
  {
    text: 'filters.category.sub.atticFlat',
    value: 'attic-flat',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.roofFlat',
    value: 'roof-flat',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.maisonette',
    value: 'maisonette',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.studio',
    value: 'studio',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.terraceFlat',
    value: 'terrace-flat',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.loft',
    value: 'loft',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.gardenFlat',
    value: 'garden-flat',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.floorFlat',
    value: 'floor-flat',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.holidayFlat',
    value: 'holiday-flat',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.furnishedFlat',
    value: 'furnished-flat',
    isChecked: false,
  },
];

export const availableHouseSubcategories: SubcategoryOption[] = [
  {
    text: 'filters.category.sub.oneFamilyHouse',
    value: 'one-family-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.semidetachedHouse',
    value: 'semidetached-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.twoFamilyHouse',
    value: 'two-family-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.midTerraceHouse',
    value: 'mid-terrace-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.endTerraceHouse',
    value: 'end-terrace-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.terraceHouse',
    value: 'terrace-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.farmhouse',
    value: 'farmhouse',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.rustico',
    value: 'rustico',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.mansion',
    value: 'mansion',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.holidayHouse',
    value: 'holiday-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.countryHouse',
    value: 'country-house',
    isChecked: false,
  },
  {
    text: 'filters.category.sub.chalet',
    value: 'chalet',
    isChecked: false,
  },
];

export const categoryToSubcategoriesMap: SubcategoryOptionsMap = {
  ['all']: [],
  ['house']: availableHouseSubcategories,
  ['flat']: availableApartmentSubcategories,
  ['land']: availableEstateSubcategories,
  ['income']: availableIncomePropertySubcategories,
  ['commercial']: availableIndustrySubcategories,
};

export function getSubcategoriesForCategory(
  category: Category
): SubcategoryOption[] {
  return categoryToSubcategoriesMap[category];
}

export function cloneSubcategoryFilter(
  source: SubcategoryOptionsMap
): SubcategoryOptionsMap {
  const clonedFilter: Partial<SubcategoryOptionsMap> = {};

  for (const filterKey in source) {
    const category = filterKey as Category;
    clonedFilter[category] = source[category].map((option) => {
      return { ...option };
    });
  }

  return clonedFilter as SubcategoryOptionsMap;
}
